import { css } from '@emotion/react';

export default $ => {
  return css`
    .react-select,
    .autocomplete,
    .autocomplete-container {
      width: 100%;

      .autocomplete__control,
      .react-select__control {
        position: relative;
        height: fit-content;
        border-color: ${$.inputBorderColor};
        border-radius: ${$.inputBorderRadius};
        min-height: 40px;
        cursor: pointer;

        &:hover {
          border-color: ${$.primaryMain};
        }

        &--is-focused {
          border-color: ${$.primaryMain} !important;
          box-shadow: none !important;
        }

        &:hover {
          border-color: ${$.inputBorderColor};
        }
      }
    }

    .autocomplete__value-container--has-value {
      font-weight: 400;
    }

    /* Remove the vertical divider between input and arrow */
    .react-select__indicator-separator,
    .autocomplete__indicator-separator {
      display: none !important;
    }

    /* Replace react-select's SVG with Bootstrap's chevron */
    .react-select__dropdown-indicator,
    .autocomplete__dropdown-indicator {
      padding: 8px 10px 8px 4px;

      svg {
        display: none;
      }

      &::after {
        content: '';
        display: block;
        width: 16px;
        height: 12px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='${encodeURIComponent(
          $.primaryMain
        )}' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 16px 12px;
      }
    }

    .react-select__menu,
    .autocomplete__menu {
      z-index: 20;
    }

    .react-select__placeholder,
    .autocomplete__placeholder {
      color: ${$.gray400} !important;
    }

    .react-select__option,
    .autocomplete__option {
      &--is-focused {
        background-color: ${$.primaryMain}18;
      }

      &--is-selected {
        background-color: ${$.primaryMain};
      }
    }

    .react-select__multi-value,
    .autocomplete__multi-value {
      background-color: ${$.primaryMain}18;

      &__label {
        color: ${$.primaryMain};
      }

      &__remove {
        color: ${$.primaryMain};

        &:hover {
          background-color: ${$.primaryMain};
          color: ${$.primaryTextMain};
        }
      }
    }

    .autocomplete-sm {
        min-height: 32px;
        height: 32px;

        .autocomplete__control {
          min-height: 32px;
          height: 32px;
          font-size: ${$.fontSizeSm};
        }
    }

    .input-group-prepend + .autocomplete-container {
        .autocomplete__control {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          border-left: 0;
        }
    }

    .autocomplete-container:has(+ .input-group-append) {
        .autocomplete__control {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-right: 0;
        }
    }
  `;
};
